exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/*#header-container {\r\n  width: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n#header-container table tr td {\r\n  white-space: nowrap;\r\n}*/\n#logo-small[data-v-21ce952e] {\r\n  max-width: 3cm;\r\n  width: auto;\r\n  height: auto;\n}\n.spacer[data-v-21ce952e]{\r\n  width: 20%;\n}\n.small-text[data-v-21ce952e] {\r\n  font-size: 10px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-21ce952e","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ReportHeader.vue
// module id = tfWn
// module chunks = 70